import { render } from "./pdf-viewer.vue?vue&type=template&id=2952e02e&scoped=true&ts=true"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts"

import "./pdf-viewer.vue?vue&type=style&index=0&id=2952e02e&lang=css"
import "./pdf-viewer.vue?vue&type=style&index=1&id=2952e02e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2952e02e"]])

export default __exports__